import * as React from 'react';
import { SVGProps } from 'react';

const SvgDelete = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='1em'
    height='1em'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <g clipPath='url(#delete_svg__a)' fill='#000'>
      <path d='M10.5 9H9v9h1.5V9ZM15 9h-1.5v9H15V9Z' />
      <path d='M3 4.5V6h1.5v15A1.5 1.5 0 0 0 6 22.5h12a1.5 1.5 0 0 0 1.5-1.5V6H21V4.5H3ZM6 21V6h12v15H6ZM15 1.5H9V3h6V1.5Z' />
    </g>
    <defs>
      <clipPath id='delete_svg__a'>
        <path fill='#fff' d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
);

export default SvgDelete;
